module.exports = __webpack_public_path__ + "img/8-low.94f8f6d5.jpg";